import { useQuery } from "@tanstack/react-query";

import OrgService from "@/api/services/org";

export function useOrg() {
  return useQuery({
    queryKey: ["org"],
    queryFn: () => OrgService.getOrg(),
  });
}
